import { createFeatureSelector } from '@ngrx/store';

import { FilterCriteria } from '../../models/searchcriteria.global';
import { SEARCH_CRITERIA_REDUCER_KEY } from '../reducers/searchCriteria.reducer';

const reducerKey = (SEARCH_CRITERIA_REDUCER_KEY as string) || 'searchCriteria';

export const selectSearchCriteriaState$ = createFeatureSelector<FilterCriteria>(reducerKey);
